import { render, staticRenderFns } from "./BetOutcomes.vue?vue&type=template&id=108e45c6"
import script from "./BetOutcomes.vue?vue&type=script&lang=js"
export * from "./BetOutcomes.vue?vue&type=script&lang=js"
import style0 from "./BetOutcomes.vue?vue&type=style&index=0&id=108e45c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports